import { api } from "@/api";

export const deleteLeagueMapping = async (
  leagueId: number,
  id: number
): Promise<void> => {
  await api.client.delete(`/leagues-new/${leagueId}/mappings/${id}`);
};
